export const fonts = {
  body: 'Roboto',
  heading: 'Montserrat',
  mono: 'Roboto'
};

export const fontWeights = {
  normal: 500,
  medium: 600,
  bold: 700
};

export const fontSizes = {
  xs: '11px',
  sm: '13px',
  md: '15px',
  lg: '17px',
  xl: '19px',
  '2xl': '24px',
  '3xl': '28px',
  '4xl': '36px',
  '5xl': '48px',
  '6xl': '64px'
};
